import { Record, Map } from 'immutable';

import MerchantRecord from './merchant';
import { convertRawValues } from '../lib/utils/record_utils';

export default class OrderRecord extends Record({
  id: null,
  _type: '',
  loan_id: '',
  merchant_id: '',
  order_key: '',
  company_id: null,
  entity_id: null,
  entity_type: '',
  created_at: '',
  merchant_order_id: null,
  shipping_address: null,
  merchant_customer_id: null,
  total_balance: '',
  status: '',
  amount: '',
  amount_refunded: '',
  product_type: '',
  merchant: new MerchantRecord(),
  product: {},
  virtual_card_details: new Map(),
  transaction_type: '',
}) {
  constructor(data) {
    data = convertRawValues(data);

    if (data.get('merchant')) {
      data = data.set('merchant', new MerchantRecord(data.get('merchant')));
    }

    super(data);
  }

  get net_amount() {
    return this.amount - this.amount_refunded;
  }
};
